export const careerStageMapping: Record<
  string,
  { title: string; radioDesc: string; desc: string }
> = {
  'first-stage': {
    title: 'First Stage Researcher',
    radioDesc:
      'Choose this option if you are a doctoral candidate or conduct research under supervision',
    desc: 'Individuals including doctoral candidates who conduct research under supervision'
  },
  recognised: {
    title: 'Recognised Researcher',
    radioDesc:
      'Choose this option if you hold a PhD, and conduct research under supervision',
    desc: 'PhD holders that conduct research under supervision'
  },
  established: {
    title: 'Established Researcher',
    radioDesc:
      'Choose this option if you hold a PhD, and conduct research independently',
    desc: 'PhD holders that conduct research independently'
  },
  leading: {
    title: 'Leading Researcher',
    radioDesc: 'Choose this option if you lead research teams or projects',
    desc: 'Includes research group team leaders and heads of industry R&D laboratories.'
  }
};

export const defaultNavigationLinks = [
  {
    label: 'Details',
    id: 'details',
    trackingEvent: 'PROFILE_QUICK_NAVIGATION_DETAILS_CLICKED'
  },
  {
    label: 'Career Stage',
    id: 'career-stage',
    trackingEvent: 'PROFILE_QUICK_NAVIGATION_CAREER_STAGE_CLICKED'
  },
  {
    label: 'Affiliations',
    id: 'affiliations',
    trackingEvent: 'PROFILE_QUICK_NAVIGATION_AFFILIATIONS_CLICKED'
  },
  {
    label: 'Biography',
    id: 'biography',
    trackingEvent: 'PROFILE_QUICK_NAVIGATION_BIOGRAPHY_CLICKED'
  },
  {
    label: 'Research',
    id: 'research',
    trackingEvent: 'PROFILE_QUICK_NAVIGATION_RESEARCH_CLICKED'
  }
];
